export const FILTER_VALUE = 1.0 // 화면에 표시되는 비율
